import { createAction, props } from '@ngrx/store';
import { ProjectTemplateDefinition } from './models/project-template-definition.model';

export const ProjectTemplateDefinitionResolverEnteredAction = createAction(
  '[Project Template Definition Resolver] Resolver Entered ',
  props<{ templateId: number }>(),
);

export const ProjectTemplateDefinitionLoadedAction = createAction(
  '[Project Template Definition Effects] Project Template Definition Loaded',
  props<{ definition: ProjectTemplateDefinition }>(),
);

export const LoadProjectTemplateDefinitionErroredAction = createAction(
  '[Project Template Definition Effects] Load Project Template Definition Errored',
  props<{ statusCode: number }>(),
);
